export default __webpack_public_path__ + "static/test-setup-dark-890b0c575fde620e9a657596b7599cb4.png";